import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { DialogService, DynamicDialogRef, MessageService } from "primeng/api";
import { Table } from "primeng/table";

import { UtilityService } from "../../../../app/shared/utility.service";
import { GLOBAL_CONSTANT } from "../../../common/constant/global.constant";
import { DocumentsPopupComponent } from "../../../shared/component/documents-popup/documents-popup.component";
import { SessionService } from "./../../../common/services/session.service";
import { ComplaintService } from "./../../complaint-service/api/complaint.service";
import * as moment from "moment";

var pageConfigFromJson = require("../../../../assets/page-configs/complain-list.json");

@Component({
  selector: "app-complain-status-list",
  templateUrl: "./complain-status-list.component.html",
  styleUrls: ["./complain-status-list.component.scss"],
  providers: [MessageService, DialogService, DynamicDialogRef],
})
export class ComplainStatusListComponent implements OnInit {
  @Output() count = new EventEmitter<any>();
  @Output() PageData = new EventEmitter();
  @Input() _index: any;
  todayDate: any;
  expandedRows: any = {};

  currentRoute: string;
  @Input() set index(val) {
    this._index = val;
    this.validateActionPermission();
  }
  get() {
    return this._index;
  }

  @ViewChild("dt", { static: false }) dt: Table;

  _searchKey: any;
  _filterData: any;
  @Input() set searchKey(value) {
    this._searchKey = value;

    if (this.dt !== undefined) {
      this.dt.filterGlobal(this._searchKey, "contains");
    }
  }
  get searchKey() {
    return this._searchKey;
  }

  @Input() set filterData(value) {
    this._filterData = value;
    if (this.page !== undefined) {
      this._filterData.page = { number: 0, size: this.defaultPageSize };
      this.setStatusData({ index: parseInt(this._index, 10) });
    }
  }
  get filterData() {
    return this._filterData;
  }
  userRole: any;
  userRoleFlag: boolean = false;
  karyakartaRoleFlag: boolean = false;
  setStatusFlag: boolean = false;
  addCommentFlag: boolean = false;
  approveStatusFlag: boolean = false;
  officeData: any;
  userInfo: any;
  netaFlag: boolean = false;
  statusWiseData: any;
  isActionAllowed: boolean = false;
  isPagination = false;
  cols = [{}, {}, {}, {}, {}, {}];
  defaultPage: any;
  page: any;
  size: any;
  totalCount: any;
  paginationCount: any;
  data: any;
  deleteData: any;
  dialougFlag: boolean = false;
  defaultPageSize: number = 10;
  config: any;
  statusOptions: Array<any>;
  newStatus: any;
  newComment: string;
  isExpandActionAllowed: boolean = false;
  queueEditActionFlag: boolean = false;
  dataForStatus: any;
  statusHead: any;
  dataForComment: any;
  entityName: string = "profileImage";
  selectedRow: any;
  

  constructor(
    private complaintService: ComplaintService,
    private router: Router,
    private toast: MessageService,
    private sessionService: SessionService,
    public dialogService: DialogService,
    public us: UtilityService
  ) {
    this.currentRoute = "DASHBOARD";
    if (this.router.url && this.router.url.indexOf("/complain/list") !== -1) {
      this.currentRoute = "COMPLAIN_STATUS_LIST";
      this.isPagination = true;
    } else {
      this.isPagination = false;
    }
    this.defaultPage = {
      page: {
        number: 0,
        size: this.size,
      },
    };
    this.statusOptions = GLOBAL_CONSTANT.COMPLAIN_STATUS;
    this.validateActionPermission();
    this.todayDate = moment().format();
  }

  validateActionPermission() {
    if (this.router.url && this.router.url.indexOf("/complain/list") > -1) {
      let vv = this.sessionService.isVirtualView();
      if (this._index == "0" && !vv) {
        this.isActionAllowed = true;
      }
      this.isActionAllowed = true;
      this.isPagination = true;
      if (this.isPagination && this.isActionAllowed) {
        this.cols = [{}, {}, {}, {}, {}, {}, {}];
      } else {
        this.cols = [{}, {}, {}, {}, {}, {}, {}, {}];
      }
    } else {
      this.isActionAllowed = false;
      this.isPagination = false;
    }
  }

  onFilter(event) {
    let c = { count: event.filteredValue.length, index: this._index };
    this.count.emit(c);
  }

  setStatusData(e) {
    let index = e.index;
    let status;
    switch (index) {
      case 0:
        status = "UNSOLVED";
        break;
      case 1:
        status = "INPROGRESS";
        break;
      case 2:
        status = "SOLVED";
        break;
      case 3:
        status = "HOLD";
        break;
      case 4:
        status = "QUEUE";
        break;
      case 5:
        status = "STATUSUPDATEREQUESTED";
        break;
    }
    if (this.userInfo.role == "SUPER_ADMIN" && status == "QUEUE") {
      this.queueEditActionFlag = true;
    }
    if (this.userInfo.role === "KARYA_KARTA" && status !== "SOLVED") {
      this.karyakartaRoleFlag = true;
    }
    if (status == "SOLVED") {
      let solvedConfig = {
        field: "solvedDate",
        header: "SolvedDate",
        sort: false,
        filter: false,
        templateConfig: {
          name: "DATE",
          format: "dd/MM/yy",
        },
      };
      this.config["complainDataList"].columns.splice(7, 0, solvedConfig);
      this.getComplainData(status);
    } else {
      this.getComplainData(status);
    }
  }

  getComplainData(status) {
    this.complaintService
      .getComplaintDataByStatus(status, this._filterData)
      .subscribe(
        (resp: any) => {
          this.statusWiseData = resp[0];
          this.paginationCount = resp[1];
          if (this.statusWiseData) {
            let c = { count: this.paginationCount, index: this._index };
            this.count.emit(c);
          }
          if (!this.isPagination) {
            this.statusWiseData = this.statusWiseData.slice(0, 2);
          }
        },
        (error) => {}
      );
  }

  //soft Delete Call
  deleteRecord(complainBookData) {
    complainBookData.recordStatus = "DELETED";
    this.complaintService.updateData(complainBookData).subscribe((res) => {
      this.dialougFlag = false;
      this.toast.add({
        severity: "error",
        summary: "Deleted Successfully",
        detail: "Complain Box Entry Deleted Successfully !!!",
      });
    });
  }

  rowClicked($event, item) {
    let e = `edit_${item.id}`;
    let tar = "";
    if ($event && $event.target && $event.target.offsetParent) {
      tar = `${$event.target.offsetParent.id}`;
    }
    if (tar == e) {
      item.isEdit = true;
    } else {
      item.isEdit = false;
    }
  }

  documentsPopup(data) {
    let docs = JSON.parse(data.documents);
    let Doc = { docs, entityName: "Complain" };
    const ref = this.dialogService.open(DocumentsPopupComponent, {
      header: "Documents",
      width: "80%",
      styleClass: "documentPopupwp",
      data: {
        documents: Doc,
      },
      contentStyle: { "max-height": "350px", overflow: "auto" },
    });
  }

  onDataUpdated(event, rowIndex) {
    this.expandedRows = {};
  }

  getPageConfig() {
    //this.complaintService.getPageConfig().subscribe((res) => {
    // this.config = res;
    this.config = JSON.parse(JSON.stringify(pageConfigFromJson));
    if (!this.isPagination) {
      this.config.complainDataList.lazyLoad = false;
      this.config.complainDataList.pagination = false;
      this.config.complainDataList.recordsPerPage = 1;
      if (
        (this.router.url && this.router.url.indexOf("/admin-dashboard") > -1) ||
        (this.router.url &&
          this.router.url.indexOf("/karyakarta/dashboard") > -1) ||
        (this.router.url && this.router.url.indexOf("/viewer-dashboard") > -1)
      ) {
        this.isActionAllowed = true;
        this.config["complainDataList"].columns = this.config[
          "complainDataList"
        ].columns.filter((col) => ["Actions"].includes(col.header) == false);
      }
      this.setStatusData({ index: parseInt(this._index, 10) });
    }
    //});
  }

  handleEvent(event) {
  if (event.name == "LAZY_LOAD") {
      this.PageData.emit(event.event);
      this.page = this.us.PaginationPerPage(event.event);
      this.defaultPage.page.size = event.event.rows;
      this._filterData.page = this.page;
      this.setStatusData({ index: parseInt(this._index, 10) });
    }
  }

  // sample click handler from action template
  onEdit($event, rowData) {
    let complainId = rowData ? rowData.id : Number;
    this.router.navigate(["/complain/edit/" + complainId]);
  }

  onDelete($event, rowData) {
    this.dialougFlag = true;
    this.deleteData = rowData;
  }

  setStatus(rowData) {
    this.setStatusFlag = true;
    this.dataForStatus = rowData;
    this.statusHead = rowData.status;
    this.statusOptions = GLOBAL_CONSTANT[`${this.statusHead}_STATUS`];
  }

  grantStatus(rowData) {
    this.approveStatusFlag = true;
    this.selectedRow = rowData;
  }

  setComment(rowData) {
    this.addCommentFlag = true;
    this.dataForComment = rowData;
  }

  updateStatus(event, rowData) {
    // rowData.status = this.newStatus.value;

    rowData.requestedStatus = this.newStatus.value;

    if (rowData.status === "SOLVED") {
      rowData.resolvedBy = this.userInfo.id;
    }
    if(this.userInfo.role == "SUPER_ADMIN" || this.userInfo.role == "OFFICE_ADMIN"){
      rowData.status = this.newStatus.value;
      rowData.requestedStatus = "NO_STATUS";
    }
    this.complaintService.updateComplainStatus(rowData).subscribe((resp) => {
      this.setStatusFlag = false;
      setTimeout(() => {
        window.location.reload(true);
      }, 1000);
    });
  }

  approveStatus() {
    let approvedstatus = this.selectedRow.requestedStatus;
    this.selectedRow.status = approvedstatus;
    this.selectedRow.requestedStatus = "NO_STATUS";

    this.complaintService
      .updateComplainStatus(this.selectedRow)
      .subscribe((resp) => {
        this.setStatusFlag = false;
        setTimeout(() => {
          window.location.reload(true);
        }, 1000);
      });
  }
  rejectStatus() {
    this.selectedRow.requestedStatus = "NO_STATUS";
    this.complaintService
      .updateComplainStatus(this.selectedRow)
      .subscribe((resp) => {
        this.approveStatusFlag = false;
        setTimeout(() => {
          window.location.reload(true);
        }, 1000);
      });
  }

  addComment(event, rowData) {
    let d = {
      text: this.newComment,
      entityType: "COMPLAIN",
      complains: rowData.id,
    };
    this.complaintService.addComment(d).subscribe((resp) => {
      rowData.comments.push(resp);
      this.addCommentFlag = false;
      this.newComment = "";
    });
  }

  expandClick($event, rowData) {
    if (this.userInfo.role === "KARYA_KARTA" && rowData.status !== "SOLVED") {
      this.isExpandActionAllowed = true;
    }
  }

  ngOnInit() {
    this.userInfo = this.sessionService.getUserInfo();
    this.officeData = this.sessionService.getOffice();
    if (this.userInfo.role == "SUPER_ADMIN") {
      this.userRoleFlag = true;
    }
    if (this.userInfo.role == "KARYA_KARTA") {
      this.karyakartaRoleFlag = true;
    }
    this.getPageConfig();
  }
  onUndo(event: Event, rowData: any) {  
    rowData.recordStatus = 'DELETED';  
      rowData.deleted = true;   
      this.restoreData(rowData);
  }
  
  restoreData(rowData: any) {
    if (!this.restoreData) return;
    this.complaintService.restoreRecord(rowData).subscribe(
      (resp) => {
        console.log('Record restored successfully:', resp);
        this.setStatusData({ index: parseInt(this._index, 10) });
        
        this.toast.add({
          severity: 'success',
          summary: 'Restored Successfully',
          detail: 'The record has been successfully restored.',
        });
      },
          (error) => {
            console.error('Error restoring data:', error);
            this.toast.add({
              severity: 'error',
              summary: 'Error Restoring Record',
              detail: 'There was an error while restoring the record.',
            });
          }
    );
  }

}
